import styled from 'styled-components';

export const StyledDeleteContainer = styled.div`
  font-family: 'sans-serif';
  font-size: 16px;
`;
